import React from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getAgencySettingsOptions, editAgencyVisitSettingsOptions } from '@generated';
import Yup from '~/util/yup';
import { TextFormField } from '~/shared/forms/controls/fields/text-fields/TextFormField';
import { Building2 } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibraryForm } from '../shared/LibraryForm';

export const VisitAgencySettingsSection = {
	settingsView: 'visit',
	title: 'Visit Settings',
	description: 'Configure visit types and documentation requirements',
	TitleIcon: Building2
} satisfies SettingsSectionItem;

const validationSchema = Yup.object().shape({
	minimumVisitTimeDurationInMinutes: Yup.number().label('Minimum Visit Time Duration In Minutes').min(0).required(),
	maxiumumVisitTimeDurationInMinutes: Yup.number().label('Maximum Visit Time Duration In Minutes').min(0).required(),
	maxiumumTravelTimeDurationInMinutes: Yup.number().label('Maximum Travel Time Duration In Minutes').min(0).required()
});

export function VisitAgencySettingsForm() {
	const { data: settings, isLoading: isAgencyLoading } = useSuspenseQuery(getAgencySettingsOptions());

	return (
		<LibraryForm
			initialValues={{
				minimumVisitTimeDurationInMinutes: settings.minimumVisitTimeDurationInMinutes,
				maxiumumVisitTimeDurationInMinutes: settings.maxiumumVisitTimeDurationInMinutes,
				maxiumumTravelTimeDurationInMinutes: settings.maxiumumTravelTimeDurationInMinutes
			}}
			saveMutation={{
				...editAgencyVisitSettingsOptions,
				invalidateQueryKeys: [getAgencySettingsOptions().queryKey]
			}}
			validationSchema={validationSchema}
			{...VisitAgencySettingsSection}
		>
			<TextFormField name="minimumVisitTimeDurationInMinutes" />
			<TextFormField name="maxiumumVisitTimeDurationInMinutes" />
			<TextFormField name="maxiumumTravelTimeDurationInMinutes" />
		</LibraryForm>
	);
}
